// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"4ce56546","453":"11b59a7f","525":"498b3d08","772":"eb623b41","904":"db20084f","997":"65e7314e"}[chunkId] + ".chunk.js";
};